import f1 from "../assets/f1.png";
import s12 from "../assets/s12.png";

export const FDP_SYLLABUS_DATA = [
  {
    id: "fdp-1",
    title: "Faculty Development Program – Emerging Technologies",
    hours: "5 Days",
    image: f1,
    modules: [
      "AI & ML overview",
      "Industry trends",
      "Hands-on tools",
      "Curriculum design",
      "Assessment strategies",
    ],
  },
   {
    id: "comm-1",
    title: "Communication & Personality Development",
    hours: "30 hrs",
    image: s12,
modules: [
  "Introduction to workplace communication",
  "Product and service communication",
  "Time management and scheduling conversations",
  "Telephone, virtual and remote communication skills",
  "Understanding company structure and operations",
  "Collaboration and teamwork communication",
  "Social and interpersonal workplace communication",
  "Presentation skills and information sharing",
  "Seeking assistance and professional problem-solving",
],
 outcomes: [
  "Communicate confidently in professional and corporate environments",
  "Improve fluency and clarity in workplace English conversations",
  "Handle meetings, calls, and presentations effectively",
  "Strengthen problem-solving and decision-making communication",
  "Build strong professional relationships and networks",
  "Enhance career growth and promotion opportunities",
  "Develop global communication competence for multinational workplaces",
],
idealFor: [
  "Working professionals",
  "Freshers entering corporate roles",
  "Job seekers preparing for interviews",
  "Individuals aiming for career growth",
  "Professionals working in global or client-facing roles",
]
  },
];
